
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'

export default class List extends React.Component {
  static propTypes = {
    items: PropTypes.array.isRequired
  };

  render() {
    const {items} = this.props
    return (
      <ul className='detailList'>
        {!!items.length && items.map(item => (
          <li key={item} dangerouslySetInnerHTML={{__html: item}} />
        ))}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/List/index.js